// extracted by mini-css-extract-plugin
export default {"priceAmount":"VHEEW8","priceAmountSmall":"MKXJJ8","priceCurrency":"zhE2pu","priceCurrencySmall":"gpnb8T"};